export const uploadDocumentConstants = {
    START_UPLOAD_SINGLE: 'START_UPLOAD_SINGLE',
    START_UPLOAD_MULTIPLE: 'START_UPLOAD_MULTIPLE',
    FINISH_UPLOAD_SINGLE: 'FINISH_UPLOAD_SINGLE',
    FINISH_UPLOAD_MULTIPLE: 'FINISH_UPLOAD_MULTIPLE'
};

export const uploadState = {
    START: 0,
    UPLOADING_SINGLE: 1,
    UPLOADING_MULTIPLE: 7,  // ToDo: Change numbers if it works - ask Sebbe 
    PROCESSING: 2,
    WAITING_TO_SELECT_TYPE: 3,
    SELECTING_TYPE: 4,
    LOADING: 5,
    END: 6,
    END_OF_MULTIUPLOAD: 8
};


// WEBPACK FOOTER //
// ./src/constants/uploadDocument.constants.js